import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function String() {
    return (
        <Draggable id="input-string">
            <InputWrapper>
                String
                <div/>
            </InputWrapper>
        </Draggable>
    )
}

export default String
